// Lightwire packages
export const lightwirePackages = [
  {
    ID: 22559778,
    Title: "Wondernet FTTH 10/10 Lightwire LIT - Off Net",
    Price: 399.00,
    "Download speed (kbps)": 10240,
    "Upload speed (kbps)": 10240,
    Supplier: "Lightwire",
    ISP: "Wondernet"
  },
  {
    ID: 22559779,
    Title: "Wondernet FTTH 25/25 Lightwire LIT - Off Net",
    Price: 499.00,
    "Download speed (kbps)": 25600,
    "Upload speed (kbps)": 25600,
    Supplier: "Lightwire",
    ISP: "Wondernet"
  },
  {
    ID: 22559780,
    Title: "Wondernet FTTH 50/50 Lightwire LIT - Off Net",
    Price: 649.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Lightwire",
    ISP: "Wondernet"
  },
  {
    ID: 22559781,
    Title: "Wondernet FTTH 100/100 Lightwire LIT - Off Net",
    Price: 899.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Lightwire",
    ISP: "Wondernet"
  }
];